export default "__VITE_ASSET__C7GAT4OC__"